import type { SVGProps } from 'react';

type VolatilityIconProps = SVGProps<SVGSVGElement> & {
    fill?: string;
};

export const VolatilityLowIcon = ({ fill = '#ffffff', width = 24, height = 14, ...svgProps }: VolatilityIconProps) => (
    <svg width={width} height={height} viewBox="0 0 24 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
        <path
            d="M1.71436 12.25C1.71436 9.46523 2.79803 6.79451 4.72697 4.82538C6.65592 2.85625 9.27213 1.75 12.0001 1.75C14.728 1.75 17.3442 2.85625 19.2732 4.82538C21.2021 6.79451 22.2858 9.46523 22.2858 12.25"
            stroke={fill}
        />
        <path d="M12 12.25L5.14286 8.75" stroke={fill} />
        <path
            d="M12 14C12.9468 14 13.7143 13.2165 13.7143 12.25C13.7143 11.2835 12.9468 10.5 12 10.5C11.0532 10.5 10.2857 11.2835 10.2857 12.25C10.2857 13.2165 11.0532 14 12 14Z"
            fill={fill}
        />
    </svg>
);

export default VolatilityLowIcon;
